import { combineReducers } from 'redux';

import main from '../main/main.reducer';
import auth from '../pages/login/auth.reducer';
import settings from '../pages/settings/settings.reducer';
import clients from '../pages/clients/clients.reducer';
import partners from '../pages/partners/partners.reducer';
import templates from '../pages/templates/reducers';
import results from '../pages/results/reducers';

export default combineReducers({
	main,
	auth,
	settings,
	clients,
	partners,
	templates,
	results,
});
